import { Button, Drawer, Input, Label } from "@components";
import { useEffect, useState } from "react";

import styles from "../../../styles/service/service.module.scss";
import InternalBenefitAPI from "providers/InternalBenefitAPI";

export function AddCoupon({ visible, onClose, onAdd, customerId }) {
  const [code, setCode] = useState("");
  const [pin, setPin] = useState("");

  const [loading, setLoading] = useState(false);

  const isValid = code && pin && pin.length === 3;

  const addCoupon = async () => {
    setLoading(true);

    const internalBenefitAPI = new InternalBenefitAPI();

    const response = await internalBenefitAPI.addStandaloneCoupon({
      code,
      pin,
      customerId,
    });

    const errors = response.getErrors([]);
    if (errors.length > 0) {
      setLoading(false);
      return alert({ text: errors[0], buttonText: "Ok" });
    }

    onAdd();

    setLoading(false);
  };

  useEffect(() => {
    if (visible) setCode("");
  }, [visible]);

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose && onClose()}
      title="Novo cupom"
      subtitle="Carteira do cliente"
      showBackButton
      backButton={() => onClose && onClose()}
      footer={
        <Button
          design="primary"
          className="w-100"
          onClick={() => addCoupon()}
          disabled={!isValid || loading}
          loading={loading}
        >
          Adicionar
        </Button>
      }
    >
      <Label>Insira o código e o PIN</Label>

      <div className={styles.addCoupon}>
        <div className="d-flex align-center gap-10 w-100">
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 16C0 8.45753 0 4.68629 2.34315 2.34315C4.68629 0 8.45753 0 16 0H20C27.5425 0 31.3137 0 33.6569 2.34315C36 4.68629 36 8.45753 36 16V20C36 27.5425 36 31.3137 33.6569 33.6569C31.3137 36 27.5425 36 20 36H16C8.45753 36 4.68629 36 2.34315 33.6569C0 31.3137 0 27.5425 0 20V16Z"
              fill="#262626"
            />
            <path
              d="M12.4186 17.2858C12.3422 17.0008 12.5222 16.7058 12.8214 16.6257L21.4761 14.3067C21.7753 14.2265 22.0787 14.3919 22.1551 14.6769L22.369 15.4754C21.784 15.7598 21.4585 16.4044 21.6254 17.0274C21.7923 17.6504 22.3965 18.0459 23.0454 17.9997L23.2594 18.7982C23.3357 19.0831 23.1557 19.3781 22.8565 19.4583L14.2018 21.7773C13.9026 21.8574 13.5992 21.692 13.5228 21.4071L12.4186 17.2858ZM12.6834 16.1105C12.0867 16.2704 11.7254 16.8624 11.8776 17.4307L12.9819 21.552C13.1342 22.1203 13.7431 22.4523 14.3398 22.2924L22.9945 19.9734C23.5912 19.8135 23.9526 19.2215 23.8003 18.6532L23.5139 17.5843C23.4794 17.4555 23.32 17.4016 23.1847 17.4378C22.7368 17.5578 22.2806 17.3091 22.1663 16.8825C22.052 16.4558 22.3227 16.0123 22.7706 15.8923C22.9059 15.8561 23.0169 15.7297 22.9824 15.6009L22.696 14.5319C22.5437 13.9637 21.9348 13.6316 21.3381 13.7915L12.6834 16.1105ZM20.1294 15.7718C20.1111 15.7035 20.0651 15.6456 20.0014 15.6109C19.9378 15.5762 19.8617 15.5675 19.79 15.5867C19.7182 15.6059 19.6567 15.6515 19.6189 15.7134C19.5812 15.7753 19.5702 15.8484 19.5885 15.9167C19.6068 15.985 19.6529 16.0429 19.7165 16.0776C19.7802 16.1124 19.8563 16.1211 19.928 16.1018C19.9997 16.0826 20.0613 16.0371 20.099 15.9752C20.1368 15.9133 20.1478 15.8401 20.1294 15.7718ZM20.4055 16.8021C20.3872 16.7338 20.3412 16.6759 20.2775 16.6412C20.2138 16.6065 20.1378 16.5978 20.066 16.617C19.9943 16.6362 19.9328 16.6818 19.895 16.7437C19.8572 16.8056 19.8463 16.8787 19.8646 16.9471C19.8829 17.0154 19.929 17.0732 19.9926 17.108C20.0563 17.1427 20.1324 17.1514 20.2041 17.1322C20.2758 17.1129 20.3373 17.0674 20.3751 17.0055C20.4129 16.9436 20.4238 16.8704 20.4055 16.8021ZM20.4802 18.1625C20.5519 18.1433 20.6134 18.0977 20.6512 18.0358C20.689 17.9739 20.6999 17.9007 20.6816 17.8324C20.6633 17.7641 20.6172 17.7062 20.5536 17.6715C20.4899 17.6368 20.4138 17.6281 20.3421 17.6473C20.2704 17.6665 20.2089 17.7121 20.1711 17.774C20.1333 17.8359 20.1224 17.9091 20.1407 17.9774C20.159 18.0457 20.205 18.1036 20.2687 18.1383C20.3324 18.173 20.4084 18.1817 20.4802 18.1625ZM20.9577 18.8628C20.9394 18.7944 20.8933 18.7366 20.8297 18.7018C20.766 18.6671 20.6899 18.6584 20.6182 18.6776C20.5465 18.6969 20.4849 18.7424 20.4472 18.8043C20.4094 18.8662 20.3984 18.9394 20.4168 19.0077C20.4351 19.076 20.4811 19.1339 20.5448 19.1686C20.6084 19.2033 20.6845 19.212 20.7562 19.1928C20.828 19.1736 20.8895 19.128 20.9273 19.0661C20.965 19.0042 20.976 18.9311 20.9577 18.8628Z"
              fill="#6F767E"
            />
          </svg>

          <Input
            design="mini"
            onChange={(e) => setCode(e.target.value)}
            autoFocus
            placeholder="Código"
          />
          <Input
            design="mini"
            placeholder="PIN"
            onChange={(e) => setPin(e.target.value)}
            className="flex-1"
          />
        </div>
        {/* <Button
          design="default-3"
          className="w-100 mt-15"
          onClick={() => addCoupon()}
          disabled={!isValid || loading}
          loading={loading}
        >
          Validar
        </Button> */}
      </div>
    </Drawer>
  );
}
